
import './App.css';
import {BrowserRouter,Routes,Route} from 'react-router-dom'


import Home from './Home'
import Products from './Products'
import Clients from './Clients'
import Contact from './Contact'


function App() {
  return (
    <div className="App">
     
     
      <BrowserRouter>
                
                
        
                    <Routes>
        
        
                   <Route path='/' element={<Home/>}></Route>        
                 <Route path='/Home' element={<Home/>}></Route>
                 
                 
                  <Route path='/Products' element={<Products/>}></Route>
                  <Route path='/Contact' element={<Contact/>}></Route>
                  <Route path='/Clients' element={<Clients/>}></Route>
        
                  
        
                </Routes>
             
                 </BrowserRouter>    


    </div>
  );
}

export default App;
